export class Cascading {
  constructor(
    public taxonomyId: number,
    public fieldId: number,
    public key: string,
    public items: string[]) { }
}
